import Mapper from '@/models/mappers/Mapper';
import { EntityType } from '@/store/entityModules/types';
import { ProductMapper } from '@/models/mappers/ProductMapper';
import { ColorMapper } from '@/models/mappers/ColorMapper';
import { CategoryMapper } from '@/models/mappers/CategoryMapper';
import { QuantityBreakMapper } from '@/models/mappers/QuantityBreak';
import { ColorGroupMapper } from '@/models/mappers/ColorGroupMapper';
import { ProductCategoryOptionMapper } from '@/models/mappers/ProductCategoryOptionMapper';
import { ProductCategoryAttributeMapper } from '@/models/mappers/ProductCategoryAttributeMapper';
import { ShopifyProductMapper } from '@/models/mappers/ShopifyProductMapper';
import { ProductionTimeMapper } from '@/models/mappers/ProductionTime';
import { PreorderProductMapper } from '@/models/mappers/PreorderProduct';
import { FontMapper } from './FontMapper';
import { FontGroupMapper } from './FontGroupMapper';

let productMapper: ProductMapper;
let shopifyProductMapper: ShopifyProductMapper;
let colorMapper: ColorMapper;
let categoryMapper: CategoryMapper;
let quantityBreakMapper: QuantityBreakMapper;
let colorGroupMapper: ColorGroupMapper;
let productCategoryOptionMapper: ProductCategoryOptionMapper;
let productCategoryAttributeMapper: ProductCategoryAttributeMapper;
let productionTimeMapper: ProductionTimeMapper;
let preorderProductMapper: PreorderProductMapper;
let fontMapper: FontMapper;
let fontGroupMapper: FontGroupMapper;

export function getEntityMapper(entityType: EntityType): Mapper<Object, Object> {
  switch (entityType) {
    case EntityType.PRODUCT:
      if (!productMapper) productMapper = new ProductMapper();
      return productMapper;
    case EntityType.SHOPIFY_PRODUCT:
      if (!shopifyProductMapper) shopifyProductMapper = new ShopifyProductMapper();
      return shopifyProductMapper;
    case EntityType.COLOR:
      if (!colorMapper) colorMapper = new ColorMapper();
      return colorMapper;
    case EntityType.CATEGORY:
      if (!categoryMapper) categoryMapper = new CategoryMapper();
      return categoryMapper;
    case EntityType.QUANTITY_BREAK:
      if (!quantityBreakMapper) quantityBreakMapper = new QuantityBreakMapper();
      return quantityBreakMapper;
    case EntityType.COLOR_GROUP:
      if (!colorGroupMapper) colorGroupMapper = new ColorGroupMapper();
      return colorGroupMapper;
    case EntityType.PRODUCT_CATEGORY_OPTION:
      if (!productCategoryOptionMapper)
        productCategoryOptionMapper = new ProductCategoryOptionMapper();
      return productCategoryOptionMapper;
    case EntityType.PRODUCT_CATEGORY_ATTRIBUTE:
      if (!productCategoryAttributeMapper)
        productCategoryAttributeMapper = new ProductCategoryAttributeMapper();
      return productCategoryAttributeMapper;
    case EntityType.PRODUCTION_TIME:
      if (!productionTimeMapper) productionTimeMapper = new ProductionTimeMapper();
      return productionTimeMapper;
    case EntityType.PREORDER_PRODUCT:
      if (!preorderProductMapper) preorderProductMapper = new PreorderProductMapper();
      return preorderProductMapper;
    case EntityType.FONT:
      if (!fontMapper) fontMapper = new FontMapper();
      return fontMapper;
    case EntityType.FONT_GROUP:
      if (!fontGroupMapper) fontGroupMapper = new FontGroupMapper();
      return fontGroupMapper;
    default:
      throw Error(`No matching mapper found for ${entityType}!`);
  }
}
